export default __webpack_public_path__ + "static/media/about-1.5141e420.jpg";